module.exports = __webpack_public_path__ + "static/media/tap.aed2f01a.svg";